import { Card, Copyable, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Constants } from "../../../../utils";
import { Flex } from "antd";
import React from "react";

const Webhook = ({ alarmModel, isConfigured }) => {
  return (
    <div>
      <Flex gap={"1em"}>
        <Text
          level={5}
          weight={700}
          children={alarmModel.name}
          type={!isConfigured ? "primary" : "secondary"}
        />
      </Flex>
      <Card bordered className="m-10-v">
        <Text
          level={5}
          weight={700}
          className="m-10-b"
          children={Localization.general.webhook}
        />
        <Flex align="center" justify="space-between">
          <Text
            weight={600}
            type="secondary"
            children={`${Constants.Project.alarmWebhookUrl}/${alarmModel.identifier}`}
          />
          <Copyable
            level={4}
            children={`${Constants.Project.alarmWebhookUrl}/${alarmModel.identifier}`}
          />
        </Flex>
      </Card>
      <Text color="secondary" children={Localization.service_webhook.desc_2} />
    </div>
  );
};

export default Webhook;
